// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import style from './Menu.scss';

import type { MenuOption } from '../DotsMenu';

type Props = {
  id: string;
  options: MenuOption[];
};

export default class Menu extends Component<Props, void> {

  constructor(props: Props) {
    super(props);
  }

  buildOptionContent(option: MenuOption) {
    return (
      <FormattedMessage id={option.labelIntl}>{
        txt => <p className={classNames(
          { [style.lightBlue]: option.color === 'lightBlue' },
          { [style.orange]: option.color === 'orange' },
          { [style.red]: option.color === 'red' },
        )}>{option.icon && <i className={option.icon}/>}{txt}</p>
      }</FormattedMessage>
    );
  }

  render() {
    const { options, id } = this.props;
    const optionsContent = options.map((option: MenuOption, n: number) => [
      <li key={`menuOption-${n}-${Date.now()}`}>
        {option.link && <Link className={classNames({ [style.disabled]: option.disabled })}
                              to={option.link}>{this.buildOptionContent(option)}</Link>}
        {option.handler && <button className={classNames({ [style.disabled]: option.disabled })}
                                   onClick={option.handler}>{this.buildOptionContent(option)}</button>}
      </li>,
      <hr key={`menuSeparator-${n}-${Date.now()}`}
          className={style.separator}/>
    ]);
    return (
      <ul className={style.menuWrap}
          data-id={id}>
        {optionsContent}
      </ul>
    );
  }
}

Menu.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/DotsMenu/Menu/Menu.jsx